export default "__VITE_ASSET__D2O_0HQN__"